import React from 'react'
import PropTypes from 'prop-types'

export default function Refresh(props) {
  let iconStyles = {
    color: props.color
  }
  if (props.disabled) {
    iconStyles.color = '#8e8e92'
  }
  const iconProps = {
    ...props,
    ...iconStyles
  }
  return (
    <svg width={iconProps.width} height={iconProps.width} viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...iconProps}>
      <path
        d="M2.64201 1.95538C3.85172 0.907154 5.39933 0.331147 7.00001 0.33338C10.682 0.33338 13.6667 3.31805 13.6667 7.00005C13.6667 8.42405 13.22 9.74405 12.46 10.8267L10.3333 7.00005H12.3333C12.3334 5.95446 12.0262 4.93192 11.4498 4.05955C10.8734 3.18719 10.0533 2.50349 9.09146 2.09346C8.12963 1.68344 7.06849 1.56518 6.03998 1.75339C5.01148 1.9416 4.06098 2.42798 3.30668 3.15205L2.64201 1.95538ZM11.358 12.0447C10.1483 13.0929 8.60069 13.6689 7.00001 13.6667C3.31801 13.6667 0.333344 10.682 0.333344 7.00005C0.333344 5.57605 0.78001 4.25605 1.54001 3.17338L3.66668 7.00005H1.66668C1.66659 8.04563 1.97385 9.06818 2.55023 9.94054C3.12662 10.8129 3.94672 11.4966 4.90856 11.9066C5.87039 12.3167 6.93153 12.4349 7.96004 12.2467C8.98854 12.0585 9.93904 11.5721 10.6933 10.848L11.358 12.0447Z"
        fill={iconProps.color}
      />
    </svg>
  )
}

Refresh.propTypes = {
  color: PropTypes.string,
  disabled: PropTypes.bool,
  width: PropTypes.number
}

Refresh.defaultProps = {
  disabled: false,
  color: '#fafafa',
  width: 14
}
